import { ConfirmDialogComponent } from './../../../dialogs/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from './../../../services/utils.service';
import { ErrorResponse } from './../../../models/error.model';
import { GuarantiesService } from './../../../services/guaranties.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ID } from '../../../models/ID.model';

@Component({
    selector: 'app-authorization-confirm',
    templateUrl: './authorization-confirm.component.html',
    styleUrls: ['./authorization-confirm.component.scss']
})
export class AuthorizationConfirmComponent implements OnInit {

    dictum: 'aprobacion' | 'rechazo';
    authorizationId: ID;
    code: string;
    sended = false;

    constructor(
        private route: ActivatedRoute,
        private guarantiesService: GuarantiesService,
        private utilsService: UtilsService,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id && params.dictum) {
                this.dictum = params.dictum;
                this.authorizationId = params.id;
                this.reportAuthorization();
            }
        });
        this.route.queryParams.subscribe(params => {
            if (params.codigo) {
                this.code = params.codigo;
                this.reportAuthorization();
            }
        });
    }

    reportAuthorization() {
        if (this.dictum && this.authorizationId && this.code) {
            if (this.dictum === 'rechazo') {
                const dialog = this.dialog.open(ConfirmDialogComponent, {
                    data: {
                        titulo: '¿Está seguro que desea rechazar la garantía?',
                        descripcion: 'Por favor ingrese la razón del rechazo.',
                        input: 'Razón',
                        botonAceptar: 'Aceptar',
                        botonCancelar: 'Cancelar'
                    }
                });
                dialog.afterClosed().subscribe((reason: string | false) => {
                    if (reason !== false) {
                        this.sendReport(reason);
                    }
                });
            } else {
                this.sendReport();
            }
        }
    }

    sendReport(reason?: string) {
        this.guarantiesService.reportAuthorization(this.authorizationId, this.dictum, this.code, reason).subscribe(
            _ => this.sended = true,
            (error: ErrorResponse) => this.utilsService.alert('Error al informar su decisión', error.error?.descripcion)
        );
    }

}
